export const AutocompleteService = () => new google.maps.places.AutocompleteService();

export const PlacesService = () =>
  new google.maps.places.PlacesService(new google.maps.Map(document.createElement('div')));

export const generateSessionToken = (): string =>
  new google.maps.places.AutocompleteSessionToken() as string;
